import React from 'react'
import { useLocale } from '../contexts/LocaleContext'

interface Tenant {
  name: string
  shift: string
  /** The organisation's own colours, deliberately nothing like ours. */
  header: string
  button: string
  logo?: string
}

const TENANTS: Tenant[] = [
  {
    name: 'Winter Event',
    shift: 'Glühweinstand',
    header: '#1d3244',
    button: '#2a7f8f',
    logo: '/img/tenant-winter-event.png',
  },
  { name: 'Stadsloop 040', shift: 'Waterpost km 5', header: '#14532D', button: '#166534' },
  { name: 'Festival Vrij!', shift: 'Bar hoofdpodium', header: '#3b1d54', button: '#6D28D9' },
]

const TenantTheming: React.FC = () => {
  const { t } = useLocale()

  return (
    <section className="mx-auto grid max-w-[1280px] items-center gap-12 px-5 py-16 sm:px-8 lg:grid-cols-2 lg:gap-16 lg:px-14 lg:py-[88px]">
      <div>
        <h2 className="text-balance font-display text-[30px] font-bold tracking-display sm:text-[38px]">
          {t('theming.title')}
        </h2>
        <p className="mt-4 max-w-[46ch] text-[17px] leading-relaxed text-text-secondary">
          {t('theming.body')}
        </p>
        <p className="mt-3.5 text-[15px] text-text-muted">{t('theming.note')}</p>
      </div>

      <div className="flex gap-3.5">
        {TENANTS.map((tenant) => (
          <div
            key={tenant.name}
            className="flex-1 overflow-hidden rounded-lg border border-border bg-surface-card shadow-card"
          >
            <div
              className="flex min-h-[40px] items-center justify-center p-3 font-display text-[15px] font-bold text-white"
              style={{ background: tenant.header }}
            >
              {tenant.logo ? (
                <img src={tenant.logo} alt={tenant.name} className="h-10" />
              ) : (
                tenant.name
              )}
            </div>
            <div className="p-3.5">
              <div className="text-[13px] font-semibold">{tenant.shift}</div>
              <div
                className="mt-2.5 flex min-h-[40px] items-center justify-center rounded-md text-[13px] font-bold text-white"
                style={{ background: tenant.button }}
              >
                {t('theming.cta')}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default TenantTheming
